import React from 'react';
import overv3Hover from './../images/overv3Hover.png';
import infoImage from './../images/info.png';

const USER_TEXT_MAX_LENGTH = 200;
const REGLA_COMPRADAS = 'Lo comprado solo se puede vender en sus primeras 24 h, por si te arrepientes, por el 65% de lo que pagaste.';
const REGLA_OVERBOX = 'Lo que te toca en una Overbox o te regalan se vende cuando quieras, por el 65% de lo que cuesta ahora en la Tienda.';

// soloComprar: sin "Comprar y usar" (paso de compra del tutorial, components/Tutorial.jsx).
// popUpData.sell + sellFunction: en el inventario, lo que da venderla y el botón Vender.
const GeneralPopUp = ({ popUpData, onClose, isShop, buyFunction, sellFunction, submitting = false, soloComprar = false }) => {
    const [userText, setUserText] = React.useState('');
    const [textError, setTextError] = React.useState(false);
    const [sellHelp, setSellHelp] = React.useState(false);
    const [sellQty, setSellQty] = React.useState('1');
    const sell = sellFunction && popUpData.sell;
    // Cuántas vender (de 1 a las que se pueden) y lo que dan: pueden ir mezcladas compradas,
    // a lo que se pagó, y de la Overbox, al precio actual.
    const sellN = sell ? Math.min(Math.max(parseInt(sellQty, 10) || 1, 1), sell.sellable) : 0;
    const sellTotal = sell ? sell.prices.slice(0, sellN).reduce((a, b) => a + b, 0) : 0;
    const disabledStyle = submitting ? { pointerEvents: 'none', opacity: 0.6 } : undefined;
    // En la tienda el texto solo es obligatorio al "Comprar y usar" (buyType 2),
    // porque solo entonces se consume la recompensa.
    const needsText = (buyType) => popUpData.requiresText && (isShop !== 'shop' || buyType === 2);
    const handleBuy = (buyType) => {
        if (submitting) return;
        const trimmed = userText.trim();
        if (needsText(buyType) && !trimmed) {
            setTextError(true);
            return;
        }
        setTextError(false);
        buyFunction(buyType, trimmed);
    };
    const handleClose = submitting ? undefined : onClose;

    return (
        <div className='PopUp heroes'>
            <span className='PopUpClose' style={disabledStyle} onClick={handleClose}>X</span>
            <div className='PopUpTitle'>
                <img src={overv3Hover}></img>
                <h3>{popUpData.title}</h3>
            </div>
            <div className='PopUpDescription'>
                {popUpData.description}
            </div>
            {popUpData.requiresText ? <div className='popUpTextField'>
                <label className='popUpTextLabel'>{popUpData.textLabel || 'Escribe el texto para esta recompensa'}</label>
                <input
                    className='userSearch popUpTextInput'
                    type='text'
                    maxLength={USER_TEXT_MAX_LENGTH}
                    placeholder={popUpData.textExample || ''}
                    value={userText}
                    disabled={submitting}
                    onChange={(e) => {
                        setUserText(e.target.value);
                        if (textError) setTextError(false);
                    }}
                />
                {isShop === 'shop' ? <div className='popUpTextNote'>Solo necesario si compras y usas</div> : ''}
                {textError ? <div className='popUpTextError'>Escribe un texto para poder usar esta recompensa.</div> : ''}
            </div> : ''}
            {sell ? <div className='popUpTextField'>
                <span className='popUpSellLine'>
                    {sell.sellable > 0
                        ? <>{sell.sellable > 1
                            ? <>Vender <input className='userSearch popUpSellQty' type='number' min='1' max={sell.sellable} value={sellQty} disabled={submitting} aria-label='Cuántas vender'
                                onChange={(e) => setSellQty(e.target.value)} onBlur={() => setSellQty(String(sellN))} /> de {sell.sellable} te da</>
                            : 'Venderla te da'} {sellTotal} {sell.img ? <img src={sell.img} alt={sell.label} /> : sell.label}</>
                        : 'Ya no se puede vender'}
                    <button type='button' className='popUpHelp' aria-label='¿Por qué?' aria-expanded={sellHelp} onClick={() => setSellHelp(!sellHelp)}><img src={infoImage} alt='' /></button>
                </span>
                {sellHelp ? <div className='popUpTextNote'>
                    {sell.paid != null
                        ? 'La compraste por ' + sell.paid + ': hasta el ' + new Date(sell.until).toLocaleString('es-ES', { day: 'numeric', month: 'numeric', hour: '2-digit', minute: '2-digit' }) +
                            ' puedes venderla por el 65% de lo que pagaste. ' + REGLA_COMPRADAS + ' ' + REGLA_OVERBOX
                        : sell.sellable > 0
                            ? 'Te tocó en una Overbox o te la regalaron: se vende cuando quieras por el 65% de lo que cuesta ahora en la Tienda (' + sell.current + '). ' + REGLA_COMPRADAS
                            : (sell.quantity > 1 ? 'Todas las que tienes las compraste' : 'Esta la compraste') + ' hace más de 24 h. ' + REGLA_COMPRADAS + ' ' + REGLA_OVERBOX}
                    {sell.sellable > 0 && sell.quantity > sell.sellable ? ' De las ' + sell.quantity + ' que tienes, ahora puedes vender ' + sell.sellable + '.' : ''}
                </div> : ''}
            </div> : ''}
            {isShop ? <div className='PopUpShop'>
                {isShop == 'shop' && !soloComprar ?
                    <div className='PopUpShopButton' style={disabledStyle} onClick={() => handleBuy(2)}>
                        <h3>{submitting ? 'Procesando...' : 'Comprar y usar'}</h3>
                    </div> : ''}
                <div className={'PopUpShopButton' + (isShop == 'shop' ? ' tutorialComprar' : '')} style={disabledStyle} onClick={() => handleBuy(1)}>
                    <h3>{submitting ? 'Procesando...' : (isShop == 'shop' ? 'Comprar' : 'Usar')}</h3>
                </div>
                {sell && sell.sellable > 0 ? <div className='PopUpShopButton' style={disabledStyle} onClick={() => !submitting && sellFunction(sellN)}>
                    <h3>{submitting ? 'Procesando...' : 'Vender'}</h3>
                </div> : ''}
                <div className='PopUpShopButton' style={disabledStyle} onClick={handleClose}>
                    <h3>No</h3>
                </div>
            </div> : ''}
        </div>
    )
}
export default GeneralPopUp;
